
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/interview-questions",
      function () {
        return require("private-next-pages/resources/interview-questions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/interview-questions"])
      });
    }
  